import {
  COLOR_BACKGROUND_INVERSE,
  COLOR_BACKGROUND_PRIMARY,
  COLOR_BLUE_700,
  COLOR_BLUE_900,
  COLOR_GREEN_400,
  COLOR_GREEN_500,
  COLOR_NEUTRAL_200,
  COLOR_NEUTRAL_400,
  COLOR_NEUTRAL_500_A,
  COLOR_NEUTRAL_600_A,
  COLOR_NEUTRAL_700,
  COLOR_PINK_600,
  COLOR_RED_300,
  COLOR_YELLOW_300
} from '@alltrails/denali/tokens';
import { createPinMarker } from './svgMarkerComponents';

type GetFillArgs = {
  isActive?: boolean;
  isClosed?: boolean;
  isCustomRoute?: boolean;
  isSaved?: boolean;
  isCompleted?: boolean;
  isViewed?: boolean;
  isRecording?: boolean;
  priorityFill?: string;
};

const getFill = ({
  isActive = false,
  isClosed = false,
  isCustomRoute = false,
  isSaved = false,
  isCompleted = false,
  isViewed = false,
  isRecording = false,
  priorityFill
}: GetFillArgs) => {
  if (priorityFill) {
    return priorityFill;
  }
  if (isClosed && !isActive) {
    return COLOR_NEUTRAL_400;
  }
  if (isCustomRoute) {
    return isActive ? COLOR_BLUE_900 : COLOR_BLUE_700;
  }
  if (isSaved && !isActive) {
    return COLOR_PINK_600;
  }
  if (isRecording && !isActive) {
    return COLOR_NEUTRAL_700;
  }
  if (isCompleted && !isActive) {
    return COLOR_GREEN_500;
  }
  if (isActive) {
    return COLOR_BACKGROUND_INVERSE;
  }
  if (isViewed) {
    return COLOR_NEUTRAL_200;
  }

  return COLOR_BACKGROUND_PRIMARY;
};

type CreateTrailPinSvgProps = {
  imageName: string;

  trailCount: number;

  isActive?: boolean;

  isClosed?: boolean;

  isCustomRoute?: boolean;
  isSaved?: boolean;
  isCompleted?: boolean;
  isCollapsed?: boolean;
  isViewed?: boolean;
  isRecording?: boolean;
  priorityFill?: string;
};

const createTrailPinSvg = ({
  imageName,
  trailCount,
  isActive = false,
  isClosed = false,
  isCustomRoute = false,
  isSaved = false,
  isCompleted = false,
  isCollapsed = false,
  isViewed = false,
  isRecording = false,
  priorityFill
}: CreateTrailPinSvgProps) => {
  const innerFill = getFill({ isActive, isClosed, isCustomRoute, isSaved, isCompleted, isViewed, isRecording, priorityFill });
  const closedTextFill = isClosed && !isActive ? COLOR_NEUTRAL_700 : undefined;
  const getBorderFill = () => {
    if (isCollapsed && isViewed) {
      return COLOR_NEUTRAL_500_A;
    }
    if (isCollapsed && !isSaved && !isCompleted && !isClosed) {
      return COLOR_NEUTRAL_600_A;
    }
    return undefined;
  };
  const borderFill = getBorderFill();

  return createPinMarker({
    imageName,
    innerFill,
    borderFill,
    dashFill: closedTextFill,
    numberContent: trailCount > 1 && !isCustomRoute && !isRecording ? trailCount : undefined,
    renderInnerDot: !isClosed && trailCount === 1,
    renderInnerDash: isClosed && trailCount === 1,
    textFill: closedTextFill,
    renderInnerHeart: isSaved && trailCount === 1,
    renderCheckmark: (isCompleted || isRecording) && trailCount === 1,
    isCollapsed
  });
};

export const PRIORITY_HIGH_FILL = COLOR_RED_300;
export const PRIORITY_MEDIUM_FILL = COLOR_YELLOW_300;
export const PRIORITY_LOW_FILL = COLOR_GREEN_400;

export default createTrailPinSvg;
